import type { ComputedRef, Ref } from 'vue';
import { computed } from 'vue';
import { PlayerType } from '@/interface/enum';

export interface IBetSlipBalanceInput {
    isActive: ComputedRef<boolean>;
    isEnabled: ComputedRef<boolean>;
    hasEnteredStake: ComputedRef<boolean>;
    requiredBalance: ComputedRef<number>;
    minimumRequiredBalance: ComputedRef<number | null>;
    affordableStake: ComputedRef<number | null>;
    minimumStake: ComputedRef<number | null>;
    balance: Ref<number | null>;
    isShowDepositInTicketEnabled: Ref<boolean>;
    playerType: ComputedRef<PlayerType>;
}

export function useBetSlipBalance(input: IBetSlipBalanceInput) {
    const isBalanceBelowMinimumRequired = computed(() => (
        input.isActive.value
        && input.isEnabled.value
        && input.hasEnteredStake.value
        && input.balance.value !== null
        && input.minimumRequiredBalance.value !== null
        && input.balance.value < input.minimumRequiredBalance.value
    ));
    const isRequiredBalanceExceeded = computed(() => (
        input.isActive.value
        && input.isEnabled.value
        && input.hasEnteredStake.value
        && input.balance.value !== null
        && input.requiredBalance.value > input.balance.value
    ));
    const shouldShowDeposit = computed(() => (
        isBalanceBelowMinimumRequired.value
        && input.isShowDepositInTicketEnabled.value
        && [PlayerType.B2C, PlayerType.B2B2C].includes(input.playerType.value)
    ));
    const isRequiredBalanceAdjustable = computed(() => (
        !isBalanceBelowMinimumRequired.value
        && isRequiredBalanceExceeded.value
        && input.affordableStake.value !== null
        && input.minimumStake.value !== null
        && input.affordableStake.value >= input.minimumStake.value
    ));

    return {
        isBalanceBelowMinimumRequired,
        isRequiredBalanceExceeded,
        isRequiredBalanceAdjustable,
        shouldShowDeposit,
    };
}
